import React from "react";
import { useTranslation } from "react-i18next";
import ResultCard from "../../Buscar/components/ResultCard";
import CardSkeleton from "../../Buscar/components/CardSkeleton";
import { useAgendaFormat } from "../state/useAgendaFormat";

// Cabecera de un día: pill HOY + "Lunes 28 de septiembre" + "n eventos" y, a la derecha,
// "Ver más ›" (solo si count > columnas visibles; pantallas 01/12, componente 16).
export const DayHeader = ({ day, count, isToday, onMore }) => {
  const { t } = useTranslation();
  const format = useAgendaFormat();
  return (
    <div className="ag-day-header">
      <div className="ag-day-heading">
        {isToday && <span className="ag-today-pill">{t("agenda.today")}</span>}
        <h2 className="ag-day-title">{format.dayTitle(day)}</h2>
        <span className="ag-day-count">{format.events(count)}</span>
      </div>
      {onMore && (
        <button type="button" className="ag-link-button" onClick={onMore}>
          {t("search.buscar.seeMore")}
          <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
            <polyline points="9 5 16 12 9 19" />
          </svg>
        </button>
      )}
    </div>
  );
};

/** Rejilla de tarjetas con el número de columnas calculado por la página. */
export const AgendaGrid = ({ columns, items, nowMs, skeletons = 0, busy = false }) => (
  <div className="ag-grid" style={{ "--ag-columns": columns }} aria-busy={busy}>
    {items.map((content) => (
      <ResultCard key={content.id} content={content} variant="agenda" nowMs={nowMs} />
    ))}
    {Array.from({ length: skeletons }).map((_, i) => (
      <CardSkeleton key={`skeleton-${i}`} />
    ))}
  </div>
);

/**
 * Bloque de un día en la lista: UNA sola fila (tantas tarjetas como columnas; la API devuelve
 * hasta 5 por día y el front pinta las que caben).
 */
const DayBlock = ({ day, count, items, isToday, columns, nowMs, onMore }) => (
  <section className="ag-day" id={`ag-day-${day}`} data-day={day}>
    <DayHeader day={day} count={count} isToday={isToday} onMore={count > columns ? onMore : null} />
    <AgendaGrid columns={columns} items={items.slice(0, columns)} nowMs={nowMs} />
  </section>
);

/** Skeleton con la forma de un bloque de día (pantalla 07): título + una fila de tarjetas. */
export const DayBlockSkeleton = ({ columns }) => (
  <div className="ag-day ag-day--skeleton" aria-hidden="true">
    <div className="ag-skeleton-title" />
    <AgendaGrid columns={columns} items={[]} skeletons={columns} busy />
  </div>
);

export default DayBlock;
